import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  EEntityTypes,
  EOrderField,
  fetchWebGetUserFavorites,
  TWebGetUserFavoritesResponse,
} from '../../../repositories/favorites/v1/web-get-user-favorites';
import { TFavoriteEntityType } from '../../../types/favorites';
import { TThunkAction } from '../../../types/redux';
import { getFavoritesListFailure } from './getFavoritesListFailure';
import { getFavoritesListLoading } from './getFavoritesListLoading';
import { getFavoritesListSucceed } from './getFavoritesListSucceed';
import { prepareFavorites } from './mapper';

export const favoritesEntityTypes: { [key: string]: EEntityTypes[] } = {
  newbuilding: [EEntityTypes.Newbuilding],
  ads: [EEntityTypes.Commercial, EEntityTypes.Residential, EEntityTypes.Suburban],
};

export const getFavoritesList = (entity: TFavoriteEntityType, offset: number): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    dispatch(getFavoritesListLoading());

    try {
      const response: TWebGetUserFavoritesResponse = await fetchWebGetUserFavorites({
        httpApi,
        parameters: {
          orderField: EOrderField.Added,
          entityTypes: favoritesEntityTypes[entity],
          offset,
        },
      });

      if (response.statusCode !== 200) {
        throw new HttpBadStatusCodeError(
          'Не удалось загрузить список избранного',
          response.statusCode,
          'favorites.getFavoritesList',
        );
      }

      const favorites = prepareFavorites(response.response.favoriteEntities);

      dispatch(getFavoritesListSucceed(favorites));
    } catch (ex) {
      logger.error(ex, {
        domain: 'favorites.getFavoritesList',
      });

      dispatch(getFavoritesListFailure());
    }
  };
};
